<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="editPickupDropStop"
      name="editPickupDropStop"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editPickupDropStop()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editPickupDropStop() {
      this.params.context.parentComponent.editPickupDropStop(
        this.params.data.id
      );
    },
  },
};
</script>

<style>
</style>